import React from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";

import { useMembershipActive } from "../../../hooks/usePurchasedProducts";
import NotificationAlerts from "./components/NotificationAlerts/NotificationAlerts";
import Logo from "../../../images/logo-blue.png";
import MenuIcon from "@material-ui/icons/Menu";
import SearchIcon from "@material-ui/icons/Search";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import ProfileDropdown from "./components/ProfileDropdown";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import Toolbar from "@material-ui/core/Toolbar";
import isCordova from "../../../helpers/cordova-check";

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "#F1F1F5",
    zIndex: theme.zIndex.drawer + 1,
    boxShadow: "0px 3px 8px rgba(0, 0, 0, 0.05)",
    color: "#121212",
  },
  toolbar: {
    minHeight: "90px !important",
    padding: "12px 36px",
    [theme.breakpoints.down("sm")]: {
      minHeight: "64px !important",
      padding: "10px 12px",
    },
  },
  rootRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    gap: 16,
  },
  leftSide: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    width: "min(536px, 100%)",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  menuButton: {
    color: "#6B778C",
    flex: "none",
  },
  logo: {
    height: 36,
    cursor: "pointer",
    [theme.breakpoints.down("sm")]: {
      height: 26,
    },
  },
  searchButton: {
    height: 46,
    width: "100%",
    backgroundColor: "#FFFFFF",
    border: "1px solid #757575",
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 12px",
    cursor: "pointer",
  },
  searchPlaceholder: {
    fontFamily: "Open Sans",
    fontSize: 14,
    fontWeight: 400,
    lineHeight: "19px",
    letterSpacing: "-0.02em",
    color: "#757575",
  },
  searchIcon: {
    color: "#6B778C",
    fontSize: 20,
  },
  mobileSearchButton: {
    height: 40,
    width: 40,
    borderRadius: 8,
    border: "1px solid #D9DEE8",
    backgroundColor: "#FFFFFF",
    color: "#6B778C",
    flex: "none",
  },
  rightSide: {
    display: "flex",
    alignItems: "center",
    gap: 15,
  },
  upgradeButton: {
    border: "none",
    borderRadius: 8,
    padding: "10px 22px",
    background:
      "linear-gradient(106deg, rgba(0,194,255,1) 0%, rgba(13,139,255,1) 54%, rgba(44,90,255,1) 100%)",
    color: "#FFFFFF",
    textTransform: "uppercase",
    fontFamily: "Open Sans",
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
    whiteSpace: "nowrap",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  iconButtonWrap: {
    height: 40,
    width: 40,
    borderRadius: 8,
    backgroundColor: "#FFFFFF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
    cursor: "pointer",
  },
  avatarButton: {
    height: 40,
    width: 40,
    borderRadius: 81,
    border: "none",
    backgroundColor: "#5C6BC0",
    color: "#FFFFFF",
    fontFamily: "Open Sans",
    fontSize: 24,
    fontWeight: 600,
    cursor: "pointer",
  },
  avatarMenuWrap: {
    position: "relative",
  },
  avatarMenu: {
    position: "absolute",
    top: 52,
    right: 0,
    minWidth: 213,
    backgroundColor: "#FFFFFF",
    borderRadius: "24px 0 0 24px",
    boxShadow:
      "0px 0px 32px rgba(0, 0, 0, 0.12), 0px 4px 4px rgba(0, 0, 0, 0.08)",
    padding: "24px 48px",
    zIndex: theme.zIndex.modal + 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 12,
    [theme.breakpoints.down("sm")]: {
      right: -8,
      top: 46,
      padding: "20px 24px",
      minWidth: 185,
    },
  },
  avatarMenuItem: {
    width: "100%",
    border: "none",
    background: "transparent",
    color: "#253858",
    cursor: "pointer",
    textAlign: "center",
    fontFamily: "Graphik, Open Sans, sans-serif",
    fontWeight: 500,
    fontSize: 16,
    lineHeight: "20px",
    letterSpacing: "-0.02em",
    padding: "6px 0",
  },
  menuActions: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 12,
    width: "100%",
    padding: "12px 0",
  },
  loginButton: {
    width: "100%",
    borderRadius: 8,
    border: "1px solid #0D8BFF",
    backgroundColor: "#FFFFFF",
    color: "#253858",
    cursor: "pointer",
    fontFamily: "Graphik, Open Sans, sans-serif",
    fontWeight: 500,
    fontSize: 16,
    lineHeight: "20px",
    letterSpacing: "-0.02em",
    padding: "12px 24px",
  },
  signUpButton: {
    width: "100%",
    borderRadius: 8,
    border: "none",
    background:
      "linear-gradient(106deg, rgba(0,194,255,1) 0%, rgba(13,139,255,1) 54%, rgba(44,90,255,1) 100%)",
    color: "#FFFFFF",
    cursor: "pointer",
    fontFamily: "Graphik, Open Sans, sans-serif",
    fontWeight: 500,
    fontSize: 16,
    lineHeight: "20px",
    letterSpacing: "-0.02em",
    padding: "12px 24px",
  },
  closeMenuButton: {
    border: "none",
    background: "transparent",
    color: "#9199A7",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    marginTop: 4,
  },
  createFreeAccountButton: {
    borderRadius: 8,
    border: "none",
    padding: "10px 22px",
    background:
      "linear-gradient(106deg, rgba(0,194,255,1) 0%, rgba(13,139,255,1) 54%, rgba(44,90,255,1) 100%)",
    color: "#FFFFFF",
    textTransform: "uppercase",
    fontFamily: "Open Sans",
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
    whiteSpace: "nowrap",
    [theme.breakpoints.down("sm")]: {
      padding: "8px 16px",
      fontSize: 12,
    },
  },
  logInButton: {
    borderRadius: 8,
    border: "1px solid #121212",
    backgroundColor: "#FFFFFF",
    color: "#121212",
    textTransform: "uppercase",
    fontFamily: "Open Sans",
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
    whiteSpace: "nowrap",
    padding: "10px 22px",
    [theme.breakpoints.down("sm")]: {
      padding: "8px 16px",
      fontSize: 12,
    },
  },
}));

const NavBar = (props) => {
  const {
    setSideDrawerOpen,
    drawerOffset = 0,
    handleSearchClick,
    intl,
    notificationProps,
    user,
    history,
  } = props;
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { isActive: hasPremiumOrHigher } = useMembershipActive();

  const handleUpgradeClick = () => {
    history.push("/pricing-premium?plan=premium");
  };

  const handleHelpClick = () => {
    const helpUrl = "https://spiking.com/help";
    if (isCordova()) {
      window.cordova.InAppBrowser.open(helpUrl, "_system");
    } else {
      window.open(helpUrl, "_blank");
    }
  };

  const handleScoreCardClick = () => {
    const scoreCardUrl = "https://spiking.com/score-card";
    if (isCordova()) {
      window.cordova.InAppBrowser.open(scoreCardUrl, "_system");
    } else {
      window.open(scoreCardUrl, "_blank");
    }
  }

  return (
    <AppBar
      position="fixed"
      className={classes.appBar}
      style={
        drawerOffset
          ? {
              marginLeft: drawerOffset,
              width: `calc(100% - ${drawerOffset}px)`,
            }
          : {}
      }
    >
      <Toolbar className={classes.toolbar}>
        <div className={classes.rootRow}>
          <div className={classes.leftSide}>
            {isMobile ? (
              <>
                <IconButton
                  aria-label="open drawer"
                  edge="start"
                  onClick={setSideDrawerOpen}
                  className={classes.menuButton}
                >
                  <MenuIcon />
                </IconButton>
                <img
                  className={classes.logo}
                  src={Logo}
                  alt="Spiking"
                  onClick={() => history.push("/spiking-up-down")}
                />
              </>
            ) : null}
            {isMobile ? (
              <IconButton
                aria-label="Open search"
                onClick={handleSearchClick}
                className={classes.mobileSearchButton}
              >
                <SearchIcon className={classes.searchIcon} />
              </IconButton>
            ) : (
              <button
                type="button"
                onClick={handleSearchClick}
                className={classes.searchButton}
              >
                <span className={classes.searchPlaceholder}>
                  {user?.Id
                    ? intl.formatMessage({
                        id: "filter.searchCompanyOrInvestor",
                      })
                    : "Symbols, Analysts, Keywords"}
                </span>
                <SearchIcon className={classes.searchIcon} />
              </button>
            )}
          </div>

          <div className={classes.rightSide}>
            {
              <button
                type="button"
                onClick={handleScoreCardClick}
                className="hidden sm:block h-12 whitespace-nowrap rounded-lg border border-[#0D8BFF] bg-white px-[22px] text-sm font-semibold uppercase text-[#121212]"
              >
                Take Score Card
              </button>
            }
            {user?.Id ? (
              <>
                {!hasPremiumOrHigher && (
                  <button
                    type="button"
                    className={classes.upgradeButton}
                    onClick={handleUpgradeClick}
                  >
                    Upgrade To Premium
                  </button>
                )}
                {hasPremiumOrHigher && (
                  <button
                    type="button"
                    aria-label="Help center"
                    onClick={handleHelpClick}
                    className={classes.iconButtonWrap}
                  >
                    <HelpOutlineIcon
                      style={{ color: "#6B778C", fontSize: 22 }}
                    />
                  </button>
                )}
                <div className={classes.iconButtonWrap}>
                  <NotificationAlerts {...notificationProps} />
                </div>
                <ProfileDropdown user={user} history={history} />
              </>
            ) : (
              <>
                <button
                  type="button"
                  className={classes.createFreeAccountButton}
                  onClick={() => history.push("/create-account")}
                >
                  CREATE FREE ACCOUNT
                </button>
                <button
                  type="button"
                  className={classes.logInButton}
                  onClick={() => history.push("/login")}
                >
                  LOG IN
                </button>
              </>
            )}
          </div>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default withRouter(injectIntl(NavBar));
